<template>
  <section class="minimal-information">
    <main class="card p-2 shadow-none">
      <section class="formCampanha mt-2">
          <b-form>
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-form-group
                  label="Nome da Campanha*"
                  label-for="name-campanha"
                  class="mb-0"
                >
                    <b-form-input
                      v-mask="'X'.repeat(200)"
                      id="name-campanha"
                      v-model="descricaoSelecionada"
                      autocomplete="off"
                      placeholder="Dê o nome da campanha"
                      :disabled="desabilitar"
                    />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col lg="8" md="12" sm="12">
                  <b-form-group
                    label="Vacina*"
                    label-for="vaccines"
                  >
                    <v-select
                      id="vaccines"
                      v-model="form.vacinas"
                      :options="formVacinas"
                      :closeOnSelect="false"
                      multiselect
                      multiple
                      :selectable="() => form.vacinas.length < 3"
                      label="nome_tecnico"
                      placeholder="Selecione uma ou mais"
                      :disabled="desabilitar"
                    >
                      <span slot="no-options">Nenhuma opção selecionável.</span>
                    </v-select>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="6" sm="12">
                  <b-form-group
                    label="Data de Início*"
                    label-for="inicio-input"
                  >
                    <b-input-group>
                      <b-form-input
                        class="form-control"
                        :state="errorOnDate ? false : null"
                        id="inicio-input"
                        v-mask="'##/##/####'"
                        v-model="input.data_inicio"
                        placeholder="00/00/0000"
                        autocomplete="off"
                        @input="setInput($event, 'data_inicio')"
                        :disabled="desabilitar"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          class="form-control d-flex align-items-center"
                          locale="pt-BR"
                          v-model="form.data_inicio"
                          button-only
                          right
                          :hide-header="true"
                          label-help="Selecione a data de início"
                          button-variant="custom-blue"
                          clearable
                          @input="setPicker($event, 'data_inicio')"
                          :disabled="desabilitar"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
              </b-col>
              <b-col lg="3" md="6" sm="12">
                  <b-form-group
                    label="Data de Término*"
                    label-for="termino-input"
                  >
                    <b-input-group>
                      <b-form-input
                        class="form-control"
                        :state="errorOnDate ? false : null"
                        id="termino-input"
                        v-mask="'##/##/####'"
                        v-model="input.data_termino"
                        placeholder="00/00/0000"
                        autocomplete="off"
                        @input="setInput($event, 'data_termino')"
                        :disabled="desabilitar"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          class="form-control d-flex align-items-center"
                          locale="pt-BR"
                          v-model="form.data_termino"
                          button-only
                          right
                          :hide-header="true"
                          label-help="Selecione a data de término"
                          button-variant="custom-blue"
                          clearable
                          @input="setPicker($event, 'data_termino')"
                          :disabled="desabilitar"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
              </b-col>
              <tolerancia-input
                :value="form.tolerancia_dias_pos_termino"
                :exibir="exibirCampoTolerancia"
                disabled
              />
            </b-row>
            <b-row>
              <b-col lg="12" md="12" sm="12" class="mt-2">
                <validation-provider
                    #default="{ errors }"
                    name="integracaoRnds"
                    rules="required"
                >
                  <integracao-rnds-input :integracao-rnds="form.integracaoRnds" @setIntegracaoRnds="setIntegracaoRnds" :disabled="desabilitar"/>
                  <input type="hidden" name="integracaoRnds" :value="form.integracaoRnds">
                  <small v-if="errors[0]" class="text-danger d-block">
                    Este campo é de preenchimento obrigatório.
                  </small>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
      </section>
    </main>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BBadge,
  BAlert,
  BInputGroup,
  BFormDatepicker,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import moment from "moment";
import {
  CampanhaNacionalGetState,
  CampanhaNacionalGetFormVacinas,
  CampanhaNacionalGetVacinasSelecionada,
  CampanhaNacionalSetDescricao,
  CampanhaNacionalGetDescricao,
  CampanhaNacionalSetDataInicioSelecionado,
  CampanhaNacionalGetDataInicio,
  CampanhaNacionalSetDataTerminoSelecionado,
  CampanhaNacionalGetDataTermino,
  CampanhaNacionalGetFormIntegracaoRnds,
  CampanhaNacionalSetIntegracaoRndsSelecionado,
  CampanhaNacionalGetToleranciaDiasPosTermino,
  podeVisualizarTolerancia,
} from "@/views/custom-pages/campanha-nacional/Helpers/campanhaNacionalHelpers.js";
import IntegracaoRndsInput from "@/views/components/custom/Inputs/IntegracaoRndsInput.vue";
import ToleranciaInput from "@/views/components/custom/Inputs/ToleranciaInput.vue";

export default {
  components: {
    IntegracaoRndsInput,
    ToleranciaInput,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BBadge,
    BAlert,
    BInputGroup,
    BFormDatepicker,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  data() {
    return {
      required,
      desabilitar: true,
      form: {
        nameCampanha: null,
        integracaoRnds: null,
        vacinas: [],
        data_inicio: null,
        data_termino: null,
        tolerancia_dias_pos_termino: null,
        errors: {
          nameCampanha: null,
          vacinas: null,
        },
      },
      input: {
        data_inicio: null,
        data_termino: null,
      },
      vaccines: [],
      errorOnDate: false
    };
  },

  mounted() {
    if (CampanhaNacionalGetFormIntegracaoRnds() != null) {
      this.form.integracaoRnds = CampanhaNacionalGetFormIntegracaoRnds()
    }
    if (CampanhaNacionalGetDataInicio() != null) {
      this.setPicker(CampanhaNacionalGetDataInicio(), "data_inicio");
    }
    if (CampanhaNacionalGetDataTermino() != null) {
      this.setPicker(CampanhaNacionalGetDataTermino(), "data_termino");
    }
    if (CampanhaNacionalGetVacinasSelecionada() != null) {
      this.form.vacinas = CampanhaNacionalGetVacinasSelecionada();
    }
    if (CampanhaNacionalGetToleranciaDiasPosTermino() != null) {
      this.form.tolerancia_dias_pos_termino = CampanhaNacionalGetToleranciaDiasPosTermino();
    }
  },
  methods: {
    setDataValues(campo, dataDB) {
      let data = moment(dataDB, "YYYY-MM-DD")

      this.form[campo] = dataDB;
      this.input[campo] = data.format("DD/MM/YYYY");

        campo == "data_inicio"
          ? CampanhaNacionalSetDataInicioSelecionado(dataDB)
          : CampanhaNacionalSetDataTerminoSelecionado(dataDB);
    },
    setPicker(data, campo) {
      this.setDataValues(campo, data);
    },
    setInput(data, campo) {
      if (data.length == 10) {
        const dataDB = moment(this.input[campo], "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
        this.setDataValues(campo, dataDB);
      }
    },
    setIntegracaoRnds(value) {
      this.form.integracaoRnds = value;
      CampanhaNacionalSetIntegracaoRndsSelecionado(this.form.integracaoRnds)
    }
  },

  computed: {
    campanhaNacionalState() {
      return CampanhaNacionalGetState();
    },
    formVacinas() {
      return CampanhaNacionalGetFormVacinas();
    },
    descricaoSelecionada: {
      get: () => CampanhaNacionalGetDescricao(),
      set: (value) => CampanhaNacionalSetDescricao(value),
    },
    exibirCampoTolerancia() {
      return podeVisualizarTolerancia()
    },
  },
};
</script>
